<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('totalScoreGradingRange.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('totalScoreGradingRange.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click.prevent="() => (show_form = true)"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'structure_name_en',
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.grading_definition.definition_name_en }}</td>
            <td class="text-center">{{ record.grading_definition.grade }}</td>
            <td class="text-center">{{ record.score_start }}</td>
            <td class="text-center">{{ record.score_stop }}</td>
            <td class="text-center">
              <i class="fa fa-check text-green" v-if="record.is_percentage"></i>
              <i class="fa fa-times text-red" v-else></i>
            </td>
            <td class="text-center">
              <i class="fa fa-check text-green" v-if="record.is_pass"></i>
              <i class="fa fa-times text-red" v-else></i>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a href="#" class="text-primary" @click.prevent="edit(record)">
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form action -->
      <a-modal
        v-model="show_form"
        :title="$t('totalScoreGradingRange.pageTitle')"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        @cancel="clearInput"
        width="400px"
      >
        <form-component v-model="model" :validate="errors" ref="form">
          <template v-slot:action-button>
            <ts-button class="mr-2" @click.prevent="cancelCreate">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="model.sc_grade_range_id == 0"
              class="mr-2"
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="saveNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              v-if="model.sc_grade_range_id == 0"
              color="primary"
              :waiting="waiting"
              @click.prevent="save"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="model.sc_grade_range_id != 0"
              color="primary"
              :waiting="waiting"
              @click.prevent="onUpdate"
              >{{ $t('update') }}</ts-button
            >
          </template>
        </form-component>
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import FormComponent from './form'

export default {
  name: 'totalScoreGradingRange',
  components: {
    FormComponent,
  },
  data() {
    return {
      loading: false,
      show_form: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        acp_id: null,
        sc_grade_range_id: 0,
        sc_setup_id: null,
        program_structure_id: null,
        is_percentage: false,
        score_start: null,
        score_stop: null,
        grade_definition_id: null,
        is_pass: false,
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('totalScoreGradingRange', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.totalScoreGradingRange.search
      },
      set(newValue) {
        this.$store.commit('totalScoreGradingRange/SET_SEARCH', newValue)
        this.$store.commit('totalScoreGradingRange/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { name: this.$t('totalScoreGradingRange.definition') },
        {
          name: this.$t('totalScoreGradingRange.grading'),
          style: 'text-align:center',
        },
        {
          name: this.$t('totalScoreGradingRange.minScore'),
          style: 'text-align:center',
        },
        {
          name: this.$t('totalScoreGradingRange.maxScore'),
          style: 'text-align:center',
        },
        {
          name: this.$t('totalScoreGradingRange.percentage'),
          style: 'text-align:center',
        },
        {
          name: this.$t('totalScoreGradingRange.pass'),
          style: 'text-align:center',
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' },
      ]
    },
  },
  methods: {
    ...mapActions('totalScoreGradingRange', ['store', 'update']),
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.show_form = false
          this.clearInput()
          this.fetchData()
        })
        .catch((error) => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.fetchData()
        })
        .catch((error) => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.update({
        id: this.model.sc_grade_range_id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.show_form = false
          this.clearInput()
          this.fetchData()
        })
        .catch((error) => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('totalScoreGradingRange/fetch', attributes)
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.model.acp_id = record.assessment_setup_main.acp_id
      this.model.sc_grade_range_id = record.sc_grade_range_id
      this.model.sc_setup_id = record.sc_setup_id
      this.model.program_structure_id = record.program_structure_id
      this.model.is_percentage = record.is_percentage
      this.model.score_start = record.score_start
      this.model.score_stop = record.score_stop
      this.model.grade_definition_id = record.grade_definition_id
      this.model.is_pass = record.is_pass
      this.show_form = true
    },
    cancelCreate() {
      this.show_form = false
      this.clearInput()
    },
    clearInput() {
      this.errors = new Errors()
      // this.model.acp_id = null
      this.model.sc_grade_range_id = 0
      // this.model.sc_setup_id = null
      // this.model.program_structure_id = null
      this.model.is_percentage = false
      this.model.score_start = null
      this.model.score_stop = null
      this.model.grade_definition_id = null
      this.model.is_pass = false
      this.$refs.form.cleardata()
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
}
</script>
